import React from "react";
import { BadgeCheckIcon, BarChart3Icon, CarIcon, ClipboardCheckIcon, CreditCardIcon, FileSignatureIcon, FileTextIcon, HandshakeIcon, LayoutDashboardIcon, ScrollTextIcon, SettingsIcon, UsersIcon, WarehouseIcon, FolderKanbanIcon, BoxIcon } from "lucide-react";
import { AdminPage } from "../../types/navigation";
import { DmpLogo } from "../brand/DmpLogo";
import { bn } from "../../utils/bn";
export const ADMIN_MENU: {
  id: AdminPage;
  label: string;
  icon: BoxIcon;
  group: string;
}[] = [{
  id: 'dashboard',
  label: 'ড্যাশবোর্ড',
  icon: LayoutDashboardIcon,
  group: 'প্রধান'
}, {
  id: 'cases',
  label: 'PCR ব্যবস্থাপনা',
  icon: FolderKanbanIcon,
  group: 'প্রধান'
}, {
  id: 'inventory',
  label: 'আটককৃত যানবাহন',
  icon: CarIcon,
  group: 'প্রধান'
}, {
  id: 'stations',
  label: 'ডাম্পিং স্টেশন',
  icon: WarehouseIcon,
  group: 'প্রধান'
}, {
  id: 'verification',
  label: 'কাগজপত্র যাচাই',
  icon: ClipboardCheckIcon,
  group: 'কার্যপ্রবাহ'
}, {
  id: 'payments',
  label: 'জরিমানা ও পেমেন্ট',
  icon: CreditCardIcon,
  group: 'কার্যপ্রবাহ'
}, {
  id: 'notesheet',
  label: 'ই-নথি ও নোটশিট',
  icon: FileTextIcon,
  group: 'কার্যপ্রবাহ'
}, {
  id: 'letters',
  label: 'অবমুক্তি পত্র',
  icon: FileSignatureIcon,
  group: 'কার্যপ্রবাহ'
}, {
  id: 'handover',
  label: 'যানবাহন হস্তান্তর',
  icon: HandshakeIcon,
  group: 'কার্যপ্রবাহ'
}, {
  id: 'reports',
  label: 'প্রতিবেদন ও বিশ্লেষণ',
  icon: BarChart3Icon,
  group: 'প্রশাসন'
}, {
  id: 'users',
  label: 'ব্যবহারকারী ব্যবস্থাপনা',
  icon: UsersIcon,
  group: 'প্রশাসন'
}, {
  id: 'config',
  label: 'সিস্টেম কনফিগারেশন',
  icon: SettingsIcon,
  group: 'প্রশাসন'
}, {
  id: 'audit',
  label: 'অডিট লগ',
  icon: ScrollTextIcon,
  group: 'প্রশাসন'
}];
interface Props {
  active: AdminPage;
  allowed: AdminPage[];
  onNavigate: (p: AdminPage) => void;
  counts: Partial<Record<AdminPage, number>>;
}
export function AdminSidebar({
  active,
  allowed,
  onNavigate,
  counts
}: Props) {
  const groups = Array.from(new Set(ADMIN_MENU.map(m => m.group)));
  return <aside className="hidden lg:flex w-64 shrink-0 flex-col bg-navy-900 text-white" data-id="element-7" data-mp="1lv53gaqz9czp">
      <div className="flex items-center gap-3 border-b border-white/10 px-4 py-4" data-id="element-8" data-mp="1qsdmedjy9l20">
        <DmpLogo size={42} tone="light" data-id="element-9" data-mp="1cuoz6z2eu1ts" />
        <div className="leading-tight" data-id="element-10" data-mp="1ctnm6p1u359f">
          <p className="text-sm font-bold" data-id="element-11" data-mp="1guzifdf7qoql">ডিএমপি</p>
          <p className="text-[11px] text-white/70" data-id="element-12" data-mp="1gtpi0hkw14gs">যানবাহন ডাম্পিং ও অবমুক্তকরণ ব্যবস্থাপনা</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto scroll-thin px-3 py-3" aria-label="পোর্টাল নেভিগেশন" data-id="element-13" data-mp="132avi0rrul4z">
        {groups.map(g => {
        const items = ADMIN_MENU.filter(m => m.group === g && allowed.includes(m.id));
        if (!items.length) return null;
        return <div key={g} className="mb-4" data-id="element-14" data-mp="y5swlhj4hh0k">
              <p className="px-2 pb-1.5 text-[11px] font-semibold text-white/45" data-id="element-15" data-mp="k59qify7wl11">{g}</p>
              <ul className="space-y-0.5" data-id="element-16" data-mp="k7m5ck8oif9v">
                {items.map(m => {
              const on = active === m.id;
              const n = counts[m.id];
              return <li key={m.id} data-id="element-17" data-mp="5jcef1nesz9u">
                      <button onClick={() => onNavigate(m.id)} className={`flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm transition-colors duration-150 ${on ? 'bg-white text-navy font-semibold' : 'text-white/85 hover:bg-white/10'}`} aria-current={on ? 'page' : undefined} data-id="element-18" data-mp="5ke0e15yr66c">
                        <m.icon className="h-4 w-4 shrink-0" data-id="element-19" data-mp="ajqosqchglb1" />
                        <span className="flex-1 text-left" data-id="element-20" data-mp="ogdmivc9ffi0">{m.label}</span>
                        {!!n && <span className={`rounded-full px-1.5 text-[11px] font-bold ${on ? 'bg-navy text-white' : 'bg-warning text-ink'}`} data-id="element-21" data-mp="jj3ynk4irbwa">{bn(n)}</span>}
                      </button>
                    </li>;
            })}
              </ul>
            </div>;
      })}
      </nav>
      <p className="border-t border-white/10 px-4 py-3 text-[10px] text-white/50" data-id="element-22" data-mp="177woqzygmpiz">প্রোটোটাইপ সংস্করণ ০.৯ · নমুনা তথ্য</p>
    </aside>;
}